<div class="fixed inset-0 bg-black/25 flex items-center justify-center z-50">
  <div class="bg-white rounded-xl shadow-lg w-80 p-6 relative text-center">
    <button (click)="onCancel()" class="absolute top-3 right-3 text-lg text-gray-400 hover:text-gray-900 text-4xl">
      &times;
    </button>

    <p class="mb-4 mt-4 text-gray-800 text-base leading-relaxed">
      Are you sure you want to logout?
    </p>

    <div class="flex justify-center gap-3">
      <button (click)="onConfirm()" class="bg-red-600 text-white rounded-lg px-4 py-2 text-sm hover:bg-red-500">
        <i class="pi pi-check mr-1"></i> Yes
      </button>
      <button (click)="onCancel()" class="bg-gray-200 text-gray-800 rounded-lg px-4 py-2 text-sm hover:bg-gray-300">
        <i class="pi pi-times mr-1"></i> Cancel
      </button>
    </div>
  </div>
</div>
